import React from "react";
import { Helmet } from "react-helmet";
import Body from "../Components/Body";
import { buildLocalBusinessSchema } from "../seo/schema";

const Home = () => (
  <>
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(buildLocalBusinessSchema())}</script>
    </Helmet>
    <Body />
  </>
);

export default Home;
